/**
 * @generated SignedSource<<98863c57012a3f1b4de8922da1d3c98a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type twoPostMagSectionTopWidgetSection$data = {
  readonly description: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "twoPostMagSectionTopWidgetSection";
};
export type twoPostMagSectionTopWidgetSection$key = {
  readonly " $data"?: twoPostMagSectionTopWidgetSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"twoPostMagSectionTopWidgetSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "twoPostMagSectionTopWidgetSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Section",
  "abstractKey": null
};

(node as any).hash = "846904ae990739c284f2205145e25415";

export default node;
